export default __webpack_public_path__ + "static/media/Liquid Nitrogen.f78ed951.PNG";